import { render } from "./PedidosMudancaLista.vue?vue&type=template&id=177e11b2&scoped=true"
import script from "./PedidosMudancaLista.vue?vue&type=script&lang=js"
export * from "./PedidosMudancaLista.vue?vue&type=script&lang=js"

import "./PedidosMudancaLista.vue?vue&type=style&index=0&id=177e11b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177e11b2"]])

export default __exports__